import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AuthService as auth } from '../services/firebase/firebaseService';
import Swal from 'sweetalert2';
import axios from 'axios';
import SimpleSlider from './carousel/ad_slider';
import { format } from 'date-fns';


export function AddLibrary(urlOfTheLibrary) {
    const script = document.createElement("script");
    script.src = urlOfTheLibrary;
    script.async = true;
    document.body.appendChild(script);
}

function Header() {
    const navigate = useNavigate();
    const user = useSelector(state => state.user.uid);
    const userType = useSelector(state => state.user.userType);
    const [imagesURL, setImagesURL] = useState([]);
    const [allLink, setLink] = useState([]);
    const [rotationAngle, setRotateA] = useState([]);

    const showTime = format(new Date(), 'MMddyyyyHis');
    //console.log('userType', userType)
    async function signOut() {
        const { error } = await auth.signOut();
        if (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Something happened loggin you out ${error.message} please try again`,
            });
        } else {
            Swal.fire({
                icon: 'success',
                title: 'Logged out',
            });
            navigate('./login');
        }
    }

    const [mount, setMount] = useState(1);
    const bringGaragesLoactions = useCallback(async (message) => {
        try {
            setImagesURL([]);
            setLink([]);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAdToShow', ZipCode: message.zipcode });
            const datat = response.data.data;
            //console.log('datat', datat)
            if (datat.length > 0) {
                const imageUrls = datat.map(element => process.env.REACT_APP_UPLOAD_URL + element.picture + '?time=' + showTime);
                const businessURL = datat.map(element => element.businessURL);
                const pictureA = datat.map(element => element.pictureA);
                setImagesURL(prevImagesURL => [...prevImagesURL, ...imageUrls]);
                setLink(prevImagesURL => [...prevImagesURL, ...businessURL])
                setRotateA(prevpictureA => [...prevpictureA, ...pictureA])

            } else {
                setImagesURL([process.env.REACT_APP_UPLOAD_URL + 'uploads/ads.png']);
                setLink([process.env.REACT_APP_PUBLIC_URL + 'ad-landing'])
                setRotateA([0])
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);



    useEffect(() => {
        if (mount === 1) {
            const intervalId = setInterval(() => {
                const message = JSON.parse(localStorage.getItem('fetchAd'));
                // console.log('message', message, mount);

                if (message && message.zipcode) {
                    setMount(0)
                    bringGaragesLoactions(message);
                } else {
                    setImagesURL([process.env.REACT_APP_UPLOAD_URL + 'uploads/ads.png']);
                    setLink(['/ad-landing'])
                }
            }, 1000);

            return () => clearInterval(intervalId);
        }


    }, [mount]);


    useEffect(() => {
        AddLibrary(process.env.REACT_APP_PUBLIC_URL + "/assets/js/scripts.js");
    }, []);


    const location = useLocation();

    // const handleGoBack = () => {
    //     navigate(-1);


    // };

    const showBackButton = location.pathname !== '/';
    const getPageName = (path) => {
        const pathParts = path.split('/');
        return pathParts[pathParts.length - 1];
    };


    const handleGoBack = () => {

        const pathName = location.pathname;

        const pageName = getPageName(pathName);
        if (pageName === 'search') {
            const elements = document.querySelectorAll('.tab-pane');
            let classExists = false;
            elements.forEach(element => {
                if (element.classList.contains('active')) {
                    classExists = true;
                    return;
                }
            });

            if (classExists) {
                window.location.reload();
            } else {
                navigate(-1);
            }

        } else {
            navigate(-1);
        }

    };

    const [popupVisible, setPopupVisible] = useState(false);
    const intervalRef = useRef(null);
const popupShownRef = useRef(false);


    const fetchData = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetUserbyId', id: user });
            const userMetaq = response.data.data;

            if (userMetaq.id !== 'none' && (userMetaq.userType === '' || userMetaq.userType === null)) {
                if (!popupVisible && !popupShownRef.current) { // Ensure popup is not shown repeatedly
                    popupShownRef.current = true;
                    console.log('popupVisible111', 'true')
                    setPopupVisible(true);
                    Swal.fire({
                        title: "Select Account Type",
                        html: `
                            <div class="d-flex">
                                <label for="swal-input1" class="form-label col-md-5">Account Type:</label>
                                <div class="col-md-7 d-flex">
                                    <input
                                        class="btn-check"
                                        name="AccountType"
                                        type="radio"
                                        value="Owner"
                                        id="Owner"
                                    />
                                    <label class="btn btn-outline-primary me-2" for="Owner">Owner</label>
                                    
                                    <input
                                        class="btn-check"
                                        name="AccountType"
                                        type="radio"
                                        value="Tenant"
                                        id="Tenant"
                                    />
                                    <label class="btn btn-outline-primary" for="Tenant">Tenant</label>
                                </div>
                            </div>
                            <small>Once you select your account type, you cannot revert your choice. If you plan to rent out your garage, select 'Owner.' If you are looking for a garage for yourself, select 'Tenant.'</small>
                        `,
                        showCancelButton: false,
                        allowOutsideClick: false,
                        confirmButtonColor: "#038500",
                        confirmButtonText: "YES!",
                        preConfirm: () => {
                            const userType = document.querySelector('input[name="AccountType"]:checked');
                            if (!userType) {
                                Swal.showValidationMessage('Account type is required');
                                return false;
                            }
                            return { userType: userType.value };
                        }
                    }).then(result => {
                        if (result.isConfirmed) {
                            const { userType } = result.value;
                            axios.post(`${process.env.REACT_APP_API_URL}`, {
                                action: 'UpdateuserType',
                                id: user,
                                userType: userType
                            })
                                .then(() => {
                                    Swal.fire({
                                        icon: "success",
                                        title: "User Type Updated",
                                        text: `Please complete your profile`
                                    });
                                }).then(() => {
                                    navigate('/edit_user');
                                    window.location.reload();
                                })
                                .catch(error => {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Error",
                                        text: `We have an error processing the information. Please try again.`
                                    });
                                });
                        }

                        console.log('popupVisible2222', 'false')
                        setPopupVisible(false);
                        popupShownRef.current = false;  // Reset popup state after user interaction
                    });
                }
            } else {
                clearInterval(intervalRef.current); // Stop polling when userType is no longer null
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };

    useEffect(() => {
        if (user !== 'none') {
            //    fetchData();

            intervalRef.current = setInterval(() => {
                if (!popupVisible) {
                    console.log('popupVisible0000', popupVisible)
                    fetchData();
                }
            }, 1000);

            return () => clearInterval(intervalRef.current); // Cleanup on unmount
        }
    }, [user, popupVisible]);



    return (
        <>

            <header className="fixed">
                {/* <div className="top-bar">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                <address className="contact-num">
                                    <span><i className="fa fa-phone"></i> +1 212 505 1015</span>
                                </address>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div className="log-details">
                                    <span className="login-form"><i className="la la-user"></i> <b>Login</b>/<b>Register</b></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-4 mb-2 mb-md-0 text-dark text-decoration-none  col-sm-12 col-xs-12">
                            {showBackButton &&

                                <span onClick={handleGoBack}
                                    style={{ fontSize: '2rem', position: 'absolute', left: '0px' }}
                                ><i className='la la-angle-left'></i></span>

                            }

                            <a href="/" title="">
                                <img src={`${process.env.REACT_APP_API_URL}/images/garage-logo.png `} alt="logo" style={{ width: '100%' }} />
                            </a>
                        </div>
                        <div className="col-md-3 col-sm-12 col-xs-12 text-center">

                            {
                                user !== 'none' && user !== ''
                                    ?

                                    <nav>
                                        <ul>

                                            <li className='loginButton'><a href="#" className='Iconbig'><i className="la la-user "></i> <i className="la la-chevron-down "></i></a>
                                                <ul>
                                                    {userType === 'Owner' &&
                                                        <li> <Link to='/garages' className='navigator__button'>
                                                            <i className="las la-home "></i>
                                                            <span>My garages</span>
                                                        </Link></li>
                                                    }
                                                    <li><Link to='/view-contract' className='navigator__button'>
                                                        <i className="la la-file-contract "></i>
                                                        <span>My Contract</span>
                                                    </Link>
                                                    </li>
                                                    <li><Link to='/advertisement' className='navigator__button'>
                                                        <i className="la la-youtube "></i>
                                                        <span>My Ads</span>
                                                    </Link>
                                                    </li>
                                                    <li><Link to='/edit_user' className='navigator__button' >
                                                        <i className="la la-user-edit"></i>
                                                        <span>Edit Account</span>
                                                    </Link>
                                                    </li>
                                                    <li>
                                                        <Link to='/change-password'>
                                                            <i className="la la-lock "></i>
                                                            <span>Change Password</span>
                                                        </Link>
                                                    </li>
                                                    <li><Link onClick={signOut}  >
                                                        <i className="la la-sign-out "></i>
                                                        Sign Out</Link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </nav>
                                    :
                                    <Link to={'/login'} className="btn btn-primary"><i className="la la-user"></i>
                                        <b>Login</b>/<b>Sign Up</b></Link>
                            }
                        </div>
                        <div className="col-md-5 text-end col-sm-12 col-xs-12">
                            {imagesURL && imagesURL.length > 0 &&
                                <SimpleSlider images={imagesURL} allLink={allLink} rotationAngle={rotationAngle} />
                            }

                        </div>
                        {/* <div className="menu-btn">
                            <a href="#" title="">
                                <span className="bar1"></span>
                                <span className="bar2"></span>
                                <span className="bar3"></span>
                            </a>
                        </div> */}
                    </div>
                </div>

                {/* {AddLibrary(
                    process.env.REACT_APP_PUBLIC_URL + "/assets/js/scripts.js"
                )} */}
            </header>
        </>
    );
};

export default Header;
